import "./waiting.css"

export default function Pause() {
    return (
        <>
            <div className="waiting">
                <div>
                    <h2 style={{ fontSize: 24 }}>Waiting due to Network...</h2>
                </div>
            </div>
        </>
    )
}